
import { Outlet } from 'react-router-dom'
import React from 'react'

const Help = () => {
  return (
    <Outlet/>
  )
}

export default Help